var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[(_vm.title)?_c('base-title',[_c('span',{staticStyle:{"flex":"1"}},[_vm._v(_vm._s(_vm.title))]),_vm._t("sub-com")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }